import React from 'react'
import { UrlManipulation, Strings } from '../utils'
import { userSubject, getUserInfo } from '../utils/Authentication'

// Store the previous data by triggering a useEffect on each change
const usePrevious = (data) => {
    const ref = React.useRef()
    React.useEffect(() => {
        ref.current = data
    })
    return ref.current
}

const useLogin = () => {
    const [user, setUser] = React.useState(userSubject.getUser())
    React.useEffect(() => {
        userSubject.attach(setUser)
        return () => userSubject.detach(setUser)
    }, [])

    return user
}

const useProfile = () => {
    const [user, setUser] = React.useState(userSubject.getUser())
    const [userProfile, setUserProfile] = React.useState(null)
    const [loading, setLoading] = React.useState(true)

    userSubject.attach(setUser)

    React.useEffect(() => {
        let isSubscribed = true
        if (user) {
            getUserInfo()
                .then(profileData => {
                    return {
                        ...profileData,
                        name: Strings.capitalizeName(profileData.name || profileData.first_name + ' ' + profileData.last_name),
                    }
                })
                .then(profileData => {
                    if (isSubscribed) {
                        setUserProfile(profileData)
                        setLoading(false)
                    }
                })
        }
        return () => isSubscribed = false
    }, [user])
    return [userProfile, loading]
}

const defaultParams = {
    page: 1,
    page_size: 10,
    value: [],
    deed_land_register_divisions_region: [],
    region: [],
    clause_lang: [],
    year: [],
    deed_type: [],
    subsection: null,
}

const useParams = () => {
    const [params, setParams] = React.useState({
        ...defaultParams,
        ...UrlManipulation.getParams(),
    })
    React.useEffect(() => {
        const detachFunction = UrlManipulation.history.listen(location => {
            setParams({
                ...defaultParams,
                ...UrlManipulation.getParams()
            })
        })
        return detachFunction
    }, [])
    return params
}

const useWindowLocation = () => {
    const [path, setPath] = React.useState(window.location.pathname)
    const detachFunction = UrlManipulation.history.listen(() => {
        setPath(window.location.pathname)
    })
    React.useEffect(() => detachFunction)
    return [path, detachFunction]
}

export { useLogin, usePrevious, useParams, useProfile, useWindowLocation }
